import React, { Component } from 'react'
import WidgetContainer from '../../containers/WidgetContainer'
import LeafletsContainer from './LeafletsContainer'
import type { LeafletsWidgetProps } from '../Types'

export default class Leaflets extends Component<LeafletsWidgetProps> {
  handleAnchorClick (event, location, name, id) {
    event.preventDefault()

    const {
      googleAnalytics
    } = this.props

    const isGoogleAnalyticsSet = typeof googleAnalytics !== 'undefined'

    const purchaseFieldObject = {
      id,
      name,
      category: 'letaky.promotheus.cz'
    }

    if (isGoogleAnalyticsSet) {
      googleAnalytics.handlePurchaseEvent(purchaseFieldObject).then(() => {
        document.location.href = location
      }).catch(() => {
        document.location.href = location
      })
    } else {
      document.location.href = location
    }
  }

  render () {
    const {
      activeDynamicLayout,
      isOpening,
      isOpen,
      handleToggleContent,
      widget,
      widget: {
        imageSize,
        utmMedium,
        utmSource,
        boxes
      }
    } = this.props

    const utmParams = {
      utmSource,
      utmMedium
    }

    if (!boxes || !boxes.length) return null

    return (
      <WidgetContainer
        widget={widget}
        isOpening={isOpening}
        activeDynamicLayout={activeDynamicLayout}
        isOpen={isOpen}
        handleToggleContent={handleToggleContent}
      >
        <LeafletsContainer
          boxes={boxes}
          imageSize={imageSize}
          utmParams={utmParams}
          handleAnchorClick={this.handleAnchorClick.bind(this)}
        />
      </WidgetContainer>
    )
  }
}
